import * as React from 'react';
import * as z from 'zod';
import './layout.css';
import './auth.css';
import img from '@/assets/new-logo.png';
import { Button } from '@/components/Elements';
import { Form, InputField, CheckBoxField } from '@/components/Form';
import {
  RegisterDTO,
  registerWithEmailAndPassword,
  registerWithEmailAndPasswordNew,
} from '../api/register';
import { Link, useNavigate } from 'react-router-dom';
import { ROLES } from '@/lib/authorization';
import i18next from 'i18next';
import go from '@/assets/google.png';
import GoogleLoginButton from '@/components/Authentication/GoogleLoginButton';
import email from '@/assets/email.svg';
import gmail from '@/assets/gmail.svg';
import { FormControl } from '@mui/material';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { LocationInput } from '@/components/Elements/map/MapMarker';

const schema = z
  .object({
    email: z
      .string()
      .min(1, 'Please enter email address')
      .max(35, 'Cannot exceed 35 characters')
      .email('Please enter valid email address!'),
    // company_name: z
    //   .string()
    //   .min(1, 'Please enter Company Name')
    //   .max(45, 'Cannot exceed 45 characters'),
    first_name: z
      .string()
      .min(1, 'Please enter first name')
      .max(25, 'Cannot exceed 25 characters')
      .regex(/^[a-zA-Z ]+$/, 'Name should contain alphabets only!'),
    last_name: z
      .string()
      .min(1, 'Please enter last name')
      .max(25, 'Cannot exceed 25 characters')
      .regex(/^[a-zA-Z ]+$/, 'Name should contain alphabets only!'),

    // password: z
    // .string({ required_error: "Password is Required" })
    // .min(1, "Password is Required")
    // .min(8, "Password must be atleast 8 characters")
    // .regex(
    //   /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&_])[A-Za-z\d@$!%*?&_]{8,}$/,
    //   "Password should be a combination of uppercase alphabets, numbers and special characters"
    // ),
    location: z.string().min(1, 'Please enter the location'),
    password: z
      .string()
      .min(1, 'Please enter password')
      .min(8, 'Password must be atleast 8 characters')
      .regex(
        // /^.*(?=.{3,})(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[\d\x])(?=.*[!@$#%]).*$/,
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#_])[A-Za-z\d@$!%*?&#_]{8,}$/,
        'Password should be a combination of uppercase lowercase alphabets, numbers, and special characters'
      )
      .refine((value) => !/\s/.test(value), 'Password cannot contain spaces'),
    confirmPassword: z.string().min(1, 'Please enter confirm password'),
    // terms: z.boolean({ required_error: 'Please accept terms and conditions' }),
    // terms: z.boolean().refine((val) => val === true, 'You must agree to the terms'),
    isRoleAgency: z.boolean().optional(),
  })
  .superRefine(({ terms, password, confirmPassword }, ctx) => {
    if (confirmPassword !== password) {
      ctx.addIssue({
        path: ['confirmPassword'],
        code: 'custom',
        message: 'Confirm password should be same as password',
      });
    }
    // if (terms !== true) {
    //   ctx.addIssue({
    //     path: ['terms'],
    //     code: 'custom',
    //     message: 'Please accept Terms and Conditions',
    //   });
    // }
  });

type RegisterValues = {
  first_name: string;
  last_name: string;
  email: string;
  //company_name: string;
  password: string;
  confirmPassword: string;
  terms: boolean;
  isRoleAgency: boolean;
  loginUserType: string;
  location?: string;
};

type RegisterFormProps = {
  onSuccess: (email: string) => void;
  type: ROLES;
};

export const RegisterForm = ({ onSuccess, type }: RegisterFormProps) => {
  const getValue = localStorage.getItem('registerVal')
    ? JSON.parse(localStorage.getItem('registerVal') ?? '')
    : null;
  const [termsVal, setTermVal] = React.useState<any>(getValue?.termsVal ?? false);
  const [err, setErr] = React.useState<boolean>(false);

  const [isRegistering, setRegistering] = React.useState<boolean>(false);
  const [userType, setUserType] = React.useState('');
  const [roleAgency, setIsRoleAgency] = React.useState(false);

  const [firstName, setFirstName] = React.useState();
  const [lastName, setLastName] = React.useState();
  const [email, setEmail] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [confirmPassword, setConfirmPassword] = React.useState('');
  const [value, setValue] = React.useState('');
  const [loading, setLoading] = React.useState<boolean>(false);
  const [details, setDetails] = React.useState<any>({});
  const [cordinates, setCordinates] = React.useState({
    latitude: 0,
    longitude: 0,
  });
  React.useEffect(() => {
    if (type == ROLES.AGENCY) {
      setUserType('agency');
      setIsRoleAgency(true);
    } else if (type == ROLES.LAWYER) {
      setUserType('lawyer');
    } else if (type == ROLES.CUSTOMER) {
      setUserType('customer');
    }
  }, [type]);
  const navigate = useNavigate();

  const handleChange = (val: any) => {
    setTermVal(val);
    setErr(false);
  };

  const handleSubmit = async (values: RegisterValues) => {
    try {
      if (!termsVal) {
        return setErr(true);
      }
      setRegistering(true);

      const payload: RegisterDTO = {
        first_name: values.first_name,
        last_name: values.last_name,
        password: values.password,
        email: values.email,
        // company_name: values.company_name,
        isRoleAgency: roleAgency,
        loginUserType: userType,
        terms: termsVal,
        address: values?.location,
        ...cordinates,
        ...details,
      };
      const response = await registerWithEmailAndPasswordNew(payload);
      console.log('response================', response);
      const statusCode = response?.data?.status_code || response?.status_code;
      if(statusCode === 200) {  
        onSuccess(values.email);  
          localStorage.removeItem('r  egisterVal'); 
      }
    } finally {
      setRegistering(false);
    }
  };

  const handleLocationChange = (details: {
    address: string;
    location: number[];
    lat: number;
    long: number;
    zipcode: string;
    street_name: string;
    house_number: string;
    region: string;
    city: string;
    country: string;
  }) => {
    console.log('tets================', details);
    setLoading(true);
    setDetails(details);
    setCordinates({ latitude: details?.lat, longitude: details?.long });
    setLoading(false);
  };

  return (
    <div className="register-form">
      <div className="row">
        <div className="col-md-4">
          {/* <img src={img} width="70" alt="alttext" /> */}
          <img src={img} alt="logo" className="mx-auto " />
        </div>
        <div className="col-md-8">
          {/* {roleAgency ? (
            <Button onClick={() => navigate('/auth/register')}>Register as Customer</Button>
          ) : (
            <>
              <Button onClick={() => navigate('/auth/register-agency')}>Register as Agency</Button>
              <Button onClick={() => navigate('/auth/register-lawyer')}>Register as LAwyer</Button>
            </>
          )} */}
        </div>
      </div>

      {userType == 'agency' ? (
        <>
          <div className="d-flex justify-content-between">
            <div>
              <h1 className="mb-0 mt-3">{i18next.t('Hello')},</h1>
              <h1 className="text-primary">{i18next.t('Agency')}!</h1>
            </div>
            <div className="have-account">
              <p>Have an Account ?</p>
              <Link to="/auth/login-agency">{i18next.t('Sign In')}</Link>
            </div>
          </div>
        </>
      ) : (
        <>
          {userType == 'lawyer' ? (
            <>
              <div className="d-flex justify-content-between">
                <div>
                  <h1 className="mb-0 mt-3">{i18next.t('Hello')},</h1>
                  <h1 className="text-primary">{i18next.t('lawyer')}!</h1>
                </div>
                <div className="have-account">
                  <p>Have an Account ?</p>
                  <Link to="/auth/login-lawyer">{i18next.t('Sign In')}</Link>
                </div>
              </div>
            </>
          ) : (
            // <h1 className="text-primary">{i18next.t('welcome')}!</h1>
            <>
              <div className="sign-up-header d-flex justify-content-between align-items-end">
                <div className="sign-up-logo ">
                  <h5 className="text-black fw-400 mt-4">
                    Welcome to <span className="color-ff3 fw-600">Reeipo!</span>
                  </h5>
                </div>
                <div className="have-account">
                  <p>Have an Account ?</p>
                  {/* <a href="#" className="color-ff3">
                    Sign in
                  </a> */}

                  <Link to="/auth/login-user">{i18next.t('Sign In')}</Link>
                </div>
              </div>
              <h2 className="text-black f-50 pb-3 fw-500">Sign up</h2>
              {/* <div className="login-google bg-eb rounded-10 p-2 text-center my-5 py-3">
                <a href="#" className="text-black text-decoration-none color-23 ">
                  <h5 className="fw-400 d-flex align-items-center justify-content-center gap-3 mb-0">
                    {' '}
                    <span className="ps-2">
                      <img src={go} className="img-fluid " />
                    </span>
                    Sign in with Google
                  </h5>
                </a>
              </div> */}
              <div className="social-accounts pb-2">
                <div className="d-flex">
                  <img alt="banner" src={gmail} width="24" className="mr-5" />

                  <GoogleLoginButton />
                </div>
              </div>
            </>
          )}
        </>
      )}

      <Form<RegisterValues, typeof schema>
        onSubmit={handleSubmit}
        schema={schema}
        options={{
          shouldUnregister: true,
          defaultValues: {
            first_name: getValue?.firstName,
            last_name: getValue?.lastName,
            email: getValue?.email,
            password: getValue?.password,
            confirmPassword: getValue?.confirmPassword,
          },
        }}
      >
        {({ register, formState }) => (
          <>
            <div className="row mt-4 w-100 m-auto">
              <div className="col-12 col-md-6 form-space">
                <InputField
                  type="text"
                  label={i18next.t('First name')}
                  // placeholder=""
                  error={formState.errors['first_name']}
                  registration={register('first_name', {
                    onChange: (e) => setFirstName(e.target.value),
                  })}
                />
              </div>
              <div className="col-12 col-md-6 form-space">
                <InputField
                  type="text"
                  label={i18next.t('Last name')}
                  error={formState.errors['last_name']}
                  registration={register('last_name', {
                    onChange: (e) => setLastName(e.target.value),
                  })}
                />
              </div>
              <div className="col-12">
                <InputField
                  type="email"
                  wrapperClass="mt-2"
                  label={i18next.t('Email Address')}
                  error={formState.errors['email']}
                  registration={register('email', { onChange: (e) => setEmail(e.target.value) })}
                />
              </div>
              {/* <InputField
              type="text"
              wrapperClass="mt-2"
              label={i18next.t('Company Name')}
              error={formState.errors['company_name']}
              registration={register('company_name')}
            /> */}
              <div className="col-12 ">
                <InputField
                  type="text"
                  label={i18next.t('Password')}
                  error={formState.errors['password']}
                  registration={register('password', {
                    onChange: (e) => setPassword(e.target.value),
                  })}
                  isPassword={true}
                />
              </div>
              <div className="col-12">
                <InputField
                  type="text"
                  label={i18next.t('Confirm Password')}
                  error={formState.errors['confirmPassword']}
                  registration={register('confirmPassword', {
                    onChange: (e) => setConfirmPassword(e.target.value),
                  })}
                  isPassword={true}
                />
              </div>

              <div className="col-12">
                <label>Enter Location</label>
                {loading ? (
                  'Loading.......'
                ) : (
                  <LocationInput
                    label="Location"
                    error={formState.errors['location']}
                    registration={register('location')}
                    handdleAddressChange={handleLocationChange}
                    // placeholder="Choose on Map"
                    setValue={setValue}
                    value={value}
                  />
                )}
              </div>
              <div className="tc mt-0">
                <>
                  <FormControl>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={termsVal}
                          onChange={(e: any) => handleChange(e.target.checked)}
                        />
                      }
                      label={
                        <>
                          <span className="f-14">Please accept the </span>
                          <Link to="/terms-conditions?page=Terms_And_Conditions">
                            <span
                              className="f-14"
                              onClick={() =>
                                localStorage.setItem(
                                  'registerVal',
                                  JSON.stringify({
                                    firstName,
                                    lastName,
                                    email,
                                    password,
                                    confirmPassword,
                                    termsVal,
                                  })
                                )
                              }
                            >
                              {i18next.t('Terms & Conditions')}
                            </span>
                          </Link>
                        </>
                      }
                    />
                  </FormControl>
                  {err && <p className="text-danger">Please accept terms and condition</p>}
                  {/* 
                <input
                  className="form-check-input"
                  type="checkbox"
                  value={termsVal}
                  id="check1"
                  name="check1"
                  checked={termsVal}
                  onChange={(e: any) => handleChange(e.target.checked)}
                />
                <label className="form-check-label ms-2">
                  Please accept the{' '}
                  <Link to="/terms-conditions?page=Terms_And_Conditions">
                    {i18next.t('Terms & Conditions')}
                  </Link>
                </label> */}
                </>

                {/* <input
              onChange={() => {
                methods.clearErrors("isDocument");
                methods.setTermVal("isDocument", true);
                setForm({ ...form, isDocumentNo: true, isDocumentYes: false });
              }}
              checked={form.isDocumentNo === true}
              type="checkbox"
              name="isDocument"
              className="me-3"
            /> */}
              </div>
              <div className="text-center">
                <Button
                  isLoading={isRegistering}
                  type="submit"
                  className=" mb-5 m-auto "
                  style={{ minWidth: '200px' }}
                  onClick={() => {
                    if (!termsVal) {
                      setErr(true);
                    }
                  }}
                >
                  {i18next.t('Sign Up')}
                </Button>
              </div>
            </div>
          </>
        )}
      </Form>
    </div>
  );
};
